import ReactDOM from 'react-dom'
import App from './app';
import { cartMountPoint } from './utils/constants';

ReactDOM.render(
    <App />,
    document.getElementById(cartMountPoint),
)
